import phpClient from "./phpClient";

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ImportShiftRow {
  employee_id: string;
  date: string;           // "YYYY-MM-DD"
  start_time: string | null;  // "HH:MM:SS" — null for Leave (record_type "T")
  end_time: string | null;    // "HH:MM:SS" — null for Leave (record_type "T")
  record_type: "A" | "T";    // A = attendance/shift, T = time-off/leave
}

export interface ScheduleImportResult {
  status: boolean;
  data: {
    inserted_count: number;
    batch_id: string;
  };
  message: string;
}

// ─── Submit approved schedule ─────────────────────────────────────────────────

/**
 * Sends the manager-approved schedule rows to the backend for bulk insert
 * into os_schedules_employee_shift.
 */
export const submitApprovedSchedule = async (
  schedules: ImportShiftRow[],
  approvedByName: string,
  approvedAt: string,
  approvedById?: string
): Promise<{ success: boolean; message: string }> => {
  try {
    const response = await phpClient.post<ScheduleImportResult>({
      url: "/schedule/import_upload",
      data: {
        schedules,
        approved_by_name: approvedByName,
        approved_by_id: approvedById ?? null,
        approved_at: approvedAt,
      },
    });
    return { success: response.status === true, message: response.message ?? "Import successful." };
  } catch (error: any) {
    console.error("Schedule import failed:", error);
    return { success: false, message: error.message || "Import failed." };
  }
};
